import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const contentTuningApi = {
  /**
   * MARK POST AS NOT INTERESTED
   * Endpoint: POST /api/posts/:id/not-interested
   * Body: { reason: 'optional reason' }
   * Response: { success: true, message: "We'll show you less like this" }
   */
  markNotInterested: async (postId, reason = "") => {
    return apiClient.post(`/posts/${postId}/not-interested`, { reason });
  },

  /**
   * HIDE POST
   * Endpoint: POST /api/posts/:id/hide
   * Body: {} (empty)
   * Response: { success: true, message: "Post hidden" }
   */
  hidePost: async (postId) => {
    return apiClient.post(`/posts/${postId}/hide`);
  },

  /**
   * REDUCE POST TYPE
   * Endpoint: POST /api/posts/reduce-type
   * Body: { postType: 'research'|'question'|'photo'|'collaboration' }
   * Response: { success: true, message: "We'll show less [type] posts" }
   */
  reducePostType: async (postType) => {
    return apiClient.post("/posts/reduce-type", { postType });
  },

  /**
   * MARK TOPIC AS NOT INTERESTED
   * Endpoint: POST /api/topics/:topic/not-interested
   * Response: { success: true }
   */
  markTopicNotInterested: async (topic) => {
    return apiClient.post(`/topics/${topic}/not-interested`);
  },

  /**
   * GET CONTENT PREFERENCES
   * Endpoint: GET /api/posts/content-preferences
   * Response: {
   *   hiddenPosts: [],
   *   mutedUsers: [],
   *   reducedTypes: [],
   *   notInterestedTopics: []
   * }
   */
  getContentPreferences: async () => {
    return apiClient.get("/posts/content-preferences");
  },
};

export const userManagementApi = {
  /**
   * MUTE USER
   * Endpoint: POST /api/users/:userId/mute
   * Body: {} (empty)
   * Response: { success: true, message: "User muted" }
   */
  muteUser: async (userId) => {
    return apiClient.post(`/users/${userId}/mute`);
  },

  /**
   * UNMUTE USER
   * Endpoint: DELETE /api/users/:userId/mute
   * Response: { success: true, message: "User unmuted" }
   */
  unmuteUser: async (userId) => {
    return apiClient.delete(`/users/${userId}/mute`);
  },

  /**
   * GET MUTED USERS
   * Endpoint: GET /api/users/muted
   * Response: { mutedUsers: [...] }
   */
  getMutedUsers: async () => {
    return apiClient.get("/users/muted");
  },
};

export default { contentTuningApi, userManagementApi };
